<!-- eslint-disable import/no-cycle -->
<template>
  <div>
    <section>
      <b-row>
        O seu perfil atualmente é: {{ user.role }}
      </b-row>
      <b-row>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          :disabled="show"
          variant="outline-primary"
          @click="changeRole()"
        >
          trocar tipo de usuário
        </b-button>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BCardText, BOverlay,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, BAlert, BInputGroup, BInputGroupPrepend, BForm, BFormGroup, VBTooltip,
} from 'bootstrap-vue'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { getUserData } from '@/auth/utils'
import stores from '../../functions/basics/stores'
import { codeHover } from '../components/collapse/code'
import { listTransaction } from '../../functions/basics/transactions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BModal,
    BAlert,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BCardText,
    AppCollapse,
    AppCollapseItem,
    flatPickr,
    vSelect,
    StatisticCardHorizontal,
    BOverlay,
  },
  data() {
    return {
      user: null,
    }
  },
  async mounted() {
    this.user = await getUserData()
  },
  methods: {
    changeRole() {
      if (this.user.role === 'admin') {
        this.user.role = 'client'
      } else {
        this.user.role = 'admin'
      }
      console.log(this.user)
      localStorage.setItem('userData', JSON.stringify(this.user))
      location.reload()
    },
  },
}
</script>
    <style lang="scss">
      @import '@core/scss/vue/libs/vue-flatpicker.scss';
    </style>
